export default function (props) {
  return <div className={`section-items px-2 grid grid-flow-col text-sm ${props.columnCount > 2 ? "auto-cols-[1fr]" : "grid-cols-4"}`}>{props.children}</div>;
}
